import {Checkbox, Radio, Spin} from 'antd';
import styled from 'styled-components';

interface AppProps {
    color: string
}

export const AppSpin = styled(Spin)<AppProps>`
    .ant-spin-dot-spin > .ant-spin-dot-item {
        background-color: ${props => props.color} !important;
    }

    .ant-spin-text {
        color: ${props => props.color} !important;
        display: inline-block;
        min-width: 300px;
        text-align: center;
    }
`

export const AppCheckbox = styled(Checkbox)<AppProps>`
    .ant-checkbox-wrapper:hover, .ant-checkbox:hover .ant-checkbox-inner, .ant-checkbox-input:focus + .ant-checkbox-inner {
        border-color: ${props => props.color} !important;
    }

    .ant-checkbox-checked::after {
        border: 1px solid ${props => props.color} !important;
    }

    .ant-checkbox-checked .ant-checkbox-inner {
        background-color: #DC3644 !important;
    }
`;

export const AppRadio = styled(Radio)<AppProps>`
    .ant-radio-inner::after {
        background-color: ${props => props.color};
    }

    .ant-radio-wrapper:hover .ant-radio, .ant-radio:hover .ant-radio-inner, .ant-radio-input:focus + .ant-radio-inner, .ant-radio-checked .ant-radio-inner {
        border-color: #DC3644 !important;
        background-color: #DC3644;
    }
`;
